const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/group-enrollments.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/group-enrollments")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});